// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
import * as LauncherItem$Showside from "./LauncherItem.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as LauncherContent$Showside from "./LauncherContent.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewOverlay_Lazy$Showside from "../pages/QuickViewOverlay_Lazy.bs.js";
function Launcher(Props) {
  var style = Props.style;
  var isNestedOpt = Props.isNested;
  var highlightedCategoryId = Props.highlightedCategoryId;
  var categories = Props.categories;
  var forceStyle = Props.forceStyle;
  var centeredOpt = Props.centered;
  var paddedOpt = Props.padded;
  var classNameOpt = Props.className;
  var dataTestId = Props.dataTestId;
  var sliderDataTestId = Props.sliderDataTestId;
  var sliderInsetMargin = Props.sliderInsetMargin;
  var slidesPerView = Props.slidesPerView;
  var onItemMouseEnter = Props.onItemMouseEnter;
  var onItemClick = Props.onItemClick;
  var onTrackClick = Props.onTrackClick;
  var onItemRendered = Props.onItemRendered;
  var ariaLabel = Props.ariaLabel;
  var tabIndex = Props.tabIndex;
  var theme = Props.theme;
  var isNested = isNestedOpt !== undefined ? isNestedOpt : false;
  var centered = centeredOpt !== undefined ? centeredOpt : false;
  var padded = paddedOpt !== undefined ? paddedOpt : true;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var match = RouterProvider$Showside.useRouter(undefined);
  var listPageType = match.listPageType;
  var goTo = match.goTo;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onClick = match$1.onLauncherItemClick;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, categories);
  var match$2 = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match$2.settings;
  React.useEffect(function () {
    var isAnyQuickViewStories = Belt_Array.some(categories, Category$Showside.isQuickViewStoriesEnabled);
    if (isAnyQuickViewStories && !isNested) {
      Curry._1(QuickViewOverlay_Lazy$Showside.preload, undefined);
    }
  }, [categories]);
  var match$3 = settings.mkrBio;
  var border = match$3 !== undefined && !isNested ? /* BorderBottom */1 : /* BorderNone */0;
  var match$4 = settings.mkrBio;
  var indicatorThickness = match$4 !== undefined ? /* Sm */1 : /* Normal */0;
  var match$5 = settings.mkrBio;
  var height = match$5 !== undefined ? /* Lg */1 : /* Normal */0;
  var activeCategoryPath = Belt_Array.map(Belt_Option.mapWithDefault(Belt_Option.map(activeCategory, function (category) {
    return category.id;
  }), [], function (id) {
    return Category$Showside.getCategoryPathById(categories, id);
  }), function (category) {
    return category.id;
  });
  var activeCategoryId = Belt_Option.map(Belt_Array.getBy(categories, function (category) {
    return activeCategoryPath.includes(category.id);
  }), function (category) {
    return category.id;
  });
  var match$6 = settings.indexNode;
  var activeCategoryId$1 = activeCategoryId !== undefined ? activeCategoryId : match$6 !== undefined && match$6.visibleInMenuBar && match.route !== /* NotRendered */0 && !isNested ? match$6.id : undefined;
  var activeCategoryId$2 = Belt_Option.keep(activeCategoryId$1, function (param) {
    if (Caml_obj.notequal(listPageType, /* History */1)) {
      return Caml_obj.notequal(listPageType, /* Favorites */0);
    } else {
      return false;
    }
  });
  var layout = forceStyle !== undefined ? forceStyle : isNested ? settings.nestedCategoryLayout : settings.categoryLayout;
  var size = isNested ? settings.nestedCategorySize : settings.categorySize;
  var onClick$1 = React.useCallback(Curry.__1(onClick), [onClick]);
  var onClick$2 = Belt_Option.getWithDefault(onItemClick, onClick$1);
  var onMouseEnter = Belt_Option.getWithDefault(onItemMouseEnter, function (param) {});
  var partial_arg = false;
  var items = Belt_Array.map(categories, function (param) {
    return LauncherItem$Showside.fromCategory(partial_arg, param);
  });
  var match$7 = settings.mkrBio;
  var match$8 = items.length;
  var items$1 = match$7 !== undefined && match$8 === 1 ? [] : items;
  var onChange = function (id) {
    var category = Belt_Array.getBy(categories, function (category) {
      return category.id === id;
    });
    if (category === undefined) {
      return;
    }
    Belt_Option.forEach(onTrackClick, function (onTrackClick) {
      Curry._1(onTrackClick, category);
    });
    var match = Category$Showside.Link.getCardLink(category);
    if (match === undefined) {
      return Curry._1(onClick$2, category);
    }
    switch (match.TAG | 0) {
      case /* URL */0:
        return;
      case /* Category */1:
        var match$1 = match._0;
        return Curry._3(goTo, undefined, undefined, {
          TAG: /* ListPage */1,
          _0: {
            listPageType: {
              TAG: /* Category */0,
              _0: match$1.categoryId
            },
            viewPLP: false,
            filters: match$1.filters,
            sort: undefined
          }
        });
      case /* Product */2:
        var match$2 = match._0;
        return Curry._3(goTo, undefined, undefined, {
          TAG: /* PDP */2,
          _0: {
            categoryId: undefined,
            productCategoryId: match$2.productCategoryId,
            productId: match$2.productId,
            variantId: match$2.variantId,
            zoomedPhotoIndex: undefined
          }
        });
      case /* StoreCategory */3:
        var match$3 = match._0;
        return Curry._3(goTo, undefined, undefined, {
          TAG: /* ListPage */1,
          _0: {
            listPageType: {
              TAG: /* StoreCategory */2,
              _0: {
                categoryId: match$3.categoryId,
                sourceNodeId: category.id
              }
            },
            viewPLP: false,
            filters: undefined,
            sort: match$3.sortBy
          }
        });
      case /* CustomAction */4:
        var match$4 = match._0;
        CustomScript$Showside.triggerCustomFunctionWithoutProducts(match$4.code, match$4.name, undefined, undefined);
        return;
    }
  };
  var onHover = function (id) {
    var category = Belt_Array.getBy(categories, function (category) {
      return category.id === id;
    });
    if (category !== undefined) {
      return Curry._1(onMouseEnter, category);
    }
  };
  if (Caml_obj.equal(items$1, [])) {
    return null;
  }
  var tmp = {
    items: items$1,
    layout: layout,
    size: size,
    theme: theme,
    centered: centered,
    verticallyCenter: layout === /* Labels */0,
    className: className,
    onChange: onChange,
    onHover: onHover,
    border: border,
    indicatorThickness: indicatorThickness,
    height: height
  };
  if (highlightedCategoryId !== undefined) {
    tmp.highlightValue = Caml_option.valFromOption(highlightedCategoryId);
  }
  if (activeCategoryId$2 !== undefined) {
    tmp.activeValue = Caml_option.valFromOption(activeCategoryId$2);
  }
  if (dataTestId !== undefined) {
    tmp.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (sliderDataTestId !== undefined) {
    tmp.sliderDataTestId = Caml_option.valFromOption(sliderDataTestId);
  }
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  var tmp$1 = padded ? undefined : 0;
  if (tmp$1 !== undefined) {
    tmp.padding = tmp$1;
  }
  if (onItemRendered !== undefined) {
    tmp.onItemRendered = Caml_option.valFromOption(onItemRendered);
  }
  var tmp$2 = padded ? undefined : /* Zero */3;
  if (tmp$2 !== undefined) {
    tmp.gap = Caml_option.valFromOption(tmp$2);
  }
  if (slidesPerView !== undefined) {
    tmp.slidesPerView = slidesPerView;
  }
  if (sliderInsetMargin !== undefined) {
    tmp.sliderInsetMargin = Caml_option.valFromOption(sliderInsetMargin);
  }
  if (ariaLabel !== undefined) {
    tmp.ariaLabel = Caml_option.valFromOption(ariaLabel);
  }
  if (tabIndex !== undefined) {
    tmp.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  return React.createElement(LauncherContent$Showside.make, tmp);
}
Launcher.displayName = "Launcher";
var make = React.memo(Launcher);
var $$default = make;
export { make, $$default, $$default as default };
/* make Not a pure module */